import styled from "styled-components";

export const Container = styled.section`
  margin-top: 15rem;

  h2 {
    text-align: center;
    font-size: 4rem;
    margin-bottom: 10rem;
  }

  .project-links {
    gap: 1rem;
  }

  .title-and-icon {
    display: flex !important;
    width: 100% !important;
    justify-content: space-between !important;
  }

  .title {
    color: white;
  }

  .projects {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    grid-template-rows: auto;
    gap: 2rem;
    padding: 1rem;
    overflow: hidden;

    .project {
      padding: 2rem 1.8rem;
      background-color: #2b2b2b;
      border-radius: 1.2rem;
      transition: 0.25s;
      display: flex;
      width: 100%;
      flex-direction: column;
      height: 100%;
      color: #fff;
      &:hover {
        transform: translateY(-5px);
        background-color: var(--pink);
      }

      header {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        color: var(--blue);
        margin-bottom: 3.6rem;

        a > img {
          width: 2.6rem;
        }
      }

      h3 {
        margin-bottom: 2rem;
      }

      p {
        letter-spacing: 0.12rem;
        margin-bottom: 2rem;
        a {
          color: #ffff;
          border-bottom: 1px solid var(--pink);
          transition: color 0.25s;
          &:hover {
            color: var(--pink);
          }
        }
      }

      footer {
        margin-top: auto;
        .tech-list {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          gap: 2rem;
          font-size: 1.4rem;
          opacity: 0.6;
        }
      }
    }
  }

  @media (max-width: 480px) {
    .projects {
      display: grid !important;
      grid-template-columns: 1fr !important;
      padding: 0 !important;
    }
    .tech-list {
      flex-wrap: wrap;
    }
  }

  @media (max-width: 740px) {
    .projects {
      grid-template-columns: 1fr;
    }
  }
`;
